import { useCallback, useEffect, useRef, useState } from 'react';
import { BlockerFunction, useBlocker, useNavigate } from 'react-router';

type CallbackWhenFunction = () => boolean;
type CallbackOwnNavigate = (path: string) => void;

export function useCallbackPrompt(when: boolean | CallbackWhenFunction, ownNavigate?: CallbackOwnNavigate): [boolean, () => void, () => void] {
    const navigate = useNavigate();
    const [showPrompt, setShowPrompt] = useState(false);
    const [lastLocation, setLastLocation] = useState<any>(null);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);
    const navigating = useRef<boolean>(false);

    // Lida com o bloqueio quando o usuário clicar em outra rota.
    const handleBlockedNavigation = useCallback<BlockerFunction>(
        (bf) => {
            // Se já está navegando (por chamar 'navigate'), então segue com a navegação default.
            if (navigating.current) {
                return false;
            }

            // Verifica se deve solicitar o PROMPT de confirmação.
            var w = typeof (when) == "boolean" ? when : when();
            if (w) {
                if (!confirmedNavigation && bf.currentLocation.pathname !== bf.nextLocation.pathname) {
                    setShowPrompt(true);
                    setLastLocation(bf.nextLocation.pathname);
                    return true;
                }
            }

            // Possui um navegador próprio?
            if (ownNavigate) {
                ownNavigate(bf.nextLocation.pathname);

                // Se tiver um navegador próprio, deve cancelar a navegação default, retornando true;
                return true;
            }

            // Segue com a navegação default.
            return false;
        },
        [confirmedNavigation, when, ownNavigate]
    );

    ///
    const confirmNavigation = useCallback(() => {
        setShowPrompt(false);
        setConfirmedNavigation(true);
    }, []);

    ///
    const cancelNavigation = useCallback(() => {
        setShowPrompt(false);
    }, []);

    ///
    useEffect(() => {
        if (confirmedNavigation && lastLocation) {
            navigating.current = true;

            // Navega para a página anterior ou repassa a responsabilidade de navegação para o navegador definido na inicialização.
            if (ownNavigate) ownNavigate(lastLocation);
            else navigate(lastLocation);
        }
    }, [confirmedNavigation, lastLocation]);

    ///
    useBlocker(handleBlockedNavigation);

    return [showPrompt, confirmNavigation, cancelNavigation];
}
